// The words @foodamigos/ui's chat parts show or read out, which the package has in English only (their `labels`
// props, 0.3.0); usePlatformAgentLabels hands them to each part.
export default {
  composer: {
    send: 'Invia',
    stop: 'Interrompi',
    attach: 'Allega file',
    add: 'Aggiungi',
    upload_files: 'Carica file',
  },
  attachment: {
    uploading: 'Caricamento {{percent}}%',
    uploading_file: 'Caricamento di {{name}}',
    retry: 'Riprova',
    remove: 'Rimuovi {{name}}',
    cancel: 'Annulla il caricamento di {{name}}',
  },
  // What screen readers hear for each step's state, and the collapsed list's line ("4 steps · 1 failed and was retried").
  steps: {
    pending: 'In attesa',
    running: 'In esecuzione',
    done: 'Fatto',
    failed: 'Non riuscito',
    denied: 'Rifiutato',
    background: 'In background',
    summary_one: '{{count}} passaggio',
    summary_other: '{{count}} passaggi',
    failed_count_one: '{{count}} non riusciti',
    failed_count_other: '{{count}} non riusciti',
    retried_one: '{{count}} non riuscito e ritentato',
    retried_other: '{{count}} non riusciti e ritentati',
  },
  question: {
    suggested: 'Suggerito',
    withdrawn: 'Non più necessario',
  },
  thread: {
    live_on: 'Online su {{domain}}',
    unread_one: '{{count}} nuovi',
    unread_other: '{{count}} nuovi',
    working: 'In corso',
  },
  // What screen readers hear for each row of a list that needs a look.
  checklist: {
    done: 'Fatto',
    running: 'In corso',
    waiting: 'Richiede attenzione',
    failed: 'Non riuscito',
    pending: 'Non ancora',
    skipped: 'Saltato',
  },
  lightbox: {
    enlarge: 'Ingrandisci: {{label}}',
    close: 'Chiudi',
  },
};
